import React, { useState, useEffect } from "react";
import { Popover, IconButton } from "../../element-components";
import { Flex, Grid } from "../../container-components";
import { Typography } from "../../typo-components";

const FormDeleteButton = (props) => {

  const {
    isAdd,
    text,
    isInline,
  
    inUseText,
    isItemInUseFunc,
    onClick,
    iconConfig,
    color,
  } = props

  const [isItemInUse, setIsItemInUse] = useState(false);

  useEffect(() => {
    const isItemInUse = isItemInUseFunc ? isItemInUseFunc() : false;
    setIsItemInUse(isItemInUse);
  }, []);

  return (
    !isAdd && (
      <Popover
        icon={{
          provider: "material-icons",
          name: iconConfig?.name || "delete_outline",

          color: color || "danger",
        }}
        inlinePadding
        inheritStyle
        isClick={!isItemInUse}
        style={
          !isInline && {
            position: "fixed",
            top: "15px",
            right: "80px",
            zIndex: "1001",
          }
        }
        content={
          isItemInUse ? (
            <Typography
              style={{ padding: "20px 30px" }}
              color="warning"
              textAlign="left"
              variant="t6"
            >
              {inUseText}
            </Typography>
          ) : (
            <Flex>
              <Grid
                style={{
                  gridTemplateColumns: "auto auto",
                  padding: "20px 30px",
                }}
                layout={[]}
              >
                <Flex nowrap yAlign="flex-start">
                  <Typography
                    // style={{ padding: '20px 30px' }}
                    color={color || "danger"}
                    textAlign="left"
                    variant="t6"
                  >
                    {text}
                  </Typography>
                  <div style={{ width: "15px" }} />
                </Flex>
                <IconButton
                  onClick={onClick}
                  margin="0 -10px 0 0"
                  color={color || "danger"}
                  iconConfig={{
                    size: "small",
                    name: "check",
                  }}
                  style={{ justifySelf: "flex-end" }}
                />
              </Grid>
            </Flex>
          )
        }
      />
    )
  );
};

export default FormDeleteButton;
